export const environment = {
  production: true,
  local: false,
  api: 'https://registry.bc-to.com',
  n8n: 'https://services.betterchains.com',
  services: {
    schedule: 'https://schedule.bc-to.com',
    tasks: 'https://task-settings.bc-to.com'
  },
  tasks_list_widget: 'https://angelic-adventure-production-f912.up.railway.app/tasks-widget.js'
};
